<template lang="pug">
.image-normal-container
  .image-normal(ref="imageContainer" @click="showZoom")
    slot
  div
    slot(name="buttons")

  .image-zoom-container(v-if="isZoom" @click="hideZoom")
    .image-zoom(v-if="srcZoom" @click.stop="")
      img(:src="srcZoom" :alt="altZoom")
      .close-zoom(@click="hideZoom") X Cerrar
</template>

<script>
export default {
  props: {
    src: {
      type: String
    },
    alt: {
      type: String
    },
    isImage: {
      type: Boolean,
      default: true
    }
  },

  data () {
    return {
      isZoom: false,
      srcFound: '',
      altFound: ''
    }
  },

  mounted () {
    if (this.isImage) {
      const image = this.$refs.imageContainer.querySelector('img')
      this.srcFound = image.src
      this.altFound = image.alt
    }
  },

  computed: {
    srcZoom () {
      return this.isImage ? this.srcFound : this.src
    },
    altZoom () {
      return this.isImage ? this.altFound : this.alt
    }
  },

  methods: {
    showZoom () {
      this.isZoom = true
    },
    hideZoom () {
      this.isZoom = false
    }
  }
}
</script>

<style lang="stylus" scoped>
.image-zoom-container
  position fixed
  top 0
  left 0
  width 100%
  height 100%
  background-color rgba(0, 0, 0, 0.5)
  z-index 1000
  cursor pointer
  display flex
  justify-content center
  align-items center

.image-zoom
  max-width 90%
  max-height 90vh
  width 90%
  height 90vh
  display flex
  justify-content center
  align-items center
  position relative

  img
    max-width 100%
    max-height 100%
    object-fit contain
    width auto
    height auto
    cursor default

.image-normal
  cursor pointer
  display inline-flex
  justify-content center
  align-items center

.close-zoom
  position absolute
  top -2rem
  right 0
  cursor pointer
  color white
  font-size 1rem
</style>



// WEBPACK FOOTER //
// src/components/layout/ImageZoom.vue